export default __webpack_public_path__ + "static/media/control-en.11028eee.png";